<template>
<div class="storage">
    <div class="section-image">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="text-center section-name">HITTA LÄKEMEDEL</h1>
            <br>
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row>
          <b-col>
            <b-input-group>
              <b-form-input name="search" v-validate="'required'" :class="{'validation-failed': errors.has('search')}" v-model="search" @keyup.enter.native="performStorageSearch" type="text" placeholder="Sök läkemedel"></b-form-input>
              <b-btn text="Button" variant="secondary" @click="performStorageSearch" alt="Sök i förråden" title="Sök i förråden"><i class="fa fa-search"></i></b-btn>
              <b-btn class="border-radius-edges" text="Button" variant="success" @click="performDeliverySearch" alt="Sök bland leveranser" title="Sök bland leveranser"><i class="fa fa-truck"></i></b-btn>
            </b-input-group>
          </b-col>
        </b-row>
        <b-row class="p-t-10">
          <b-col>
            <multiselect name="multiselect" v-validate="'required'" :class="{'validation-failed': errors.has('multiselect')}" v-model="value" :max="3" :showLabels="false" :searchable="value.length !== 5" :hide-selected="true" :close-on-select="false" :multiple="true" :options="cities" label="name" track-by="name" placeholder="Välj stad">
              <template slot="tag" slot-scope="props">
                <mu-chip class="chip" @delete="props.remove(props.option)" showDelete>{{ props.option.name }}</mu-chip>
              </template>
              <template slot="maxElements">Högst tre val</template>
              <template slot="noResult">Hittade ingen stad</template>
            </multiselect>
          </b-col>
        </b-row>
        <br>
      </b-container>
    </div>
    <template v-if="isLoading">
      <mu-linear-progress :size="10" color="green" />
    </template>
    <div class="container-custom">
      <b-row>
        <b-col class="text-center" v-if="searchError">
          <p>Ett oväntat fel inträffade vid sökning, Vänligen försök igen.</p>
        </b-col>
        <b-col v-else-if="storageItems.length > 0">
          <div class="storageitems">
            <h4 class="text-center">{{storageItems[0].storageLocations[0].isDelivery ? 'Leveranser' : 'Bas- och svansförråd'}}</h4>


            <div class="container-custom">
              <div class="row header">
                <div class="column col-sm-6">Artikel</div>
                <div class="column col-sm-4">Beskrivning</div>
                <div class="column col-sm-2">{{storageItems[0].storageLocations[0].isDelivery ? 'Levererad till' : 'Tillgänglighet'}}</div>
              </div>
              <template v-for="item in storageItems">
                <div class="row bg-hover mobile-boxed" :key="item.id">
                  <div class="column col-sm-6 bold-name">{{item.storageLocations[0].article.name}}</div>
                  <div class="column col-sm-4">{{item.storageLocations[0].article.description}}</div>
                  <div class="column col-sm-2 text-right"><b-button class="br-5 w-100" @click="item.storageLocations[0].showDetails = !item.storageLocations[0].showDetails">{{item.storageLocations[0].showDetails ? 'Stäng' : 'Visa'}}</b-button></div>
                </div>
                <div class="row details" v-if="item.storageLocations[0].showDetails" :key="item.id + '-details'">
                  <div class="column col-sm-12">
                    <div class="content">
                      <div class="item" v-for="location in item.storageLocations" :key="location.storageId">
                        <b-row>
                          <b-col cols="7">
                            <div>{{location.storage.storageAddress.name}}</div>
                            <div><p>{{getAddress(location.storage.storageAddress)}}</p></div>
                            <!-- <div><a :alt="getAddress(location.storage.storageAddress)" :title="getAddress(location.storage.storageAddress)" :href="getMapLink(location.storage.storageAddress)" target="_blank"><i class="fa fa-location-arrow"></i> {{getAddress(location.storage.storageAddress)}}</a></div> -->
                          </b-col>
                          <b-col cols="5" class="text-right">
                            <b-badge variant="success" v-if="location.quantity > 0">{{location.quantity}} st</b-badge>
                            <div v-if="location.isDelivery">{{location.deliveredDate.substring(0, 10)}}</div>
                            <!-- <div v-if="!location.coordsIsNull"><p>{{getAddress(location.storage.storageAddress)}}</p></div> -->
                            <!-- <div v-if="!location.coordsIsNull"><a :href="getMapLink(location.storage.storageAddress)" target="_blank">{{getFormattedDistance(location.distanceToCoord)}}</a></div> -->
                          </b-col>
                        </b-row>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </b-col>
        <b-col class="text-center" v-else-if="storageItems.length === 0 && hasSearched && !isLoading">
          <p>Inga läkemedel hittade. Gör en ny sökning!</p>
        </b-col>
        <b-col class="pl-3" v-else-if="!hasSearched">
          <b-row>
            <b-col>
              <ul>
                <li>Ange 1-3 städer (om platstjänster är aktiverat föreslår sökmotorn stad)</li>
                <li>Sökning på ”pan” resulterar i både "<u>Pan</u>odil" och "Busco<u>pan</u>"</li>
                <li>För <i>de flesta</i> preparaten är det möjligt att söka på aktiv substans, tex "Paracetamol".</li>
              </ul>
              <p class="ml-4">
                Informationen uppdateras en gång per dygn.
              </p>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="description-block">
                <div class="button-container">
                  <b-btn text="Button" variant="secondary" @click="performStorageSearch" alt="Sök i förråden" title="Sök i förråden">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </div>
                <div>
                  <div class="pb-2 pt-2">
                    <b>Sök i bas- och svansförråd</b>
                  </div>
                  <p class="pl-2 pb-2">
                    Resultatet består dels av läkemedel som finns på det aktuella förrådets bassortimentlista (kan därför tex. vara slut i verkligheten), dels av vad som finns i svansförråden.<br/>
                    <a class="link" href="https://intra.skane.se/sidor/vardinformation-och-patientservice2/vardriktlinjer/lakemedel/bestall-lakemedel/forrad-och-leveranser/" target="_blank">Svansförråd - rutinbeskrivning</a><br/>
                    Senast uppdaterad: {{updateDates.storageLastUpdateDate}}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="description-block">
                <div class="button-container">
                  <b-btn text="Button" variant="success" @click="performDeliverySearch" alt="Sök bland leveranser" title="Sök bland leveranser">
                    <i class="fa fa-truck"></i>
                  </b-btn>
                </div>
                <div>
                  <div class="pb-2 pt-2">
                    <b>Sök genomförda leveranser till läkemedelsrum</b>
                  </div>
                  <p class="pl-2 pb-2">
                    Resultatet består av både bassortiment och icke-bassortiment för genomförda leveranser. Sökningen inkluderar leveranser upp till två år tillbaka i tiden.<br/>
                    Sökresultatet sorteras efter senaste leveransdatum.<br/>
                    Senast uppdaterad: {{updateDates.deliveryLastUpdateDate}}
                  </p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { getAll, getStorageItems, getDeliveryItems, getStorageUpdateDate } from '../store/actions'
import { round, map, ceil } from 'lodash'
import { clickTracker } from '@/services/helpers'
import axios from 'axios'
const axiosInstance = axios.create()

export default {
  data () {
    return {
      storageItems: [],
      value: [],
      isLoading: false,
      search: '',
      hasSearched: false,
      locationInfo: {},
      searchError: false
    }
  },
  methods: {
    performSearch (searchFunction) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isLoading = true
          this.searchError = false
          let _this = this
          let cities = map(_this.value, ({ name }) => name).join()
          let search = this.search.trim().toLowerCase()
          _this.storageItems = []
          searchFunction(search, cities, this.locationInfo.longitude, this.locationInfo.latitude)
            .then((result) => {
              if (result.status >= 400) {
                this.searchError = true
              }
              _this.storageItems = result.data || []
            }).catch(() => {
              this.searchError = true
            })
            .finally(() => {
              _this.isLoading = false
              this.hasSearched = true
            })
        }
      })
    },
    performStorageSearch () {
      this.performSearch(getStorageItems)
    },
    performDeliverySearch () {
      this.performSearch(getDeliveryItems)
    },
    getAddress (address) {
      let visitingAddress = address.visitingAddress.split(',')[0]
      return `${visitingAddress ? visitingAddress + ', ' : ''}${address.city}`
    },
    getMapLink (address) {
      return 'https://google.com/maps/place/' + this.getAddress(address)
    },
    setLocationInfo (position) {
      this.locationInfo.longitude = position.coords.longitude
      this.locationInfo.latitude = position.coords.latitude
      if (this.locationInfo.latitude && this.locationInfo.longitude) {
        this.preselectCityFromCoords()
      }
    },
    preselectCityFromCoords () {
      let _this = this
      axiosInstance.get('https://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          latlng: _this.locationInfo.latitude + ',' + _this.locationInfo.longitude,
          key: 'AIzaSyDXA-D2OL9lT6fizg_1mfq8lLIHoU4eRKQ'
        }
      })
      .then(function (response) {
        let cityName = _this.retrieveCity(response.data.results[0].address_components)
        let city = find(_this.cities, function (city) { return city.name === cityName })
        if (city) {
          _this.value.push(city)
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    },
    getFormattedDistance (distance) {
      if (distance < 1000) {
        return round(distance, -2) + ' m'
      } else {
        let distanceInKm = distance / 1000
        return ceil(distanceInKm, 1) + ' km'
      }
    },
    retrieveCity (addresses) {
      let city = ''
      addresses.forEach(address => {
        if (address.types[0] === 'postal_town') {
          city = address.long_name
        }
      })
      return city
    }
  },
  computed: {
    cities () {
      return this.$store.state.cities
    },
    updateDates () {
      return this.$store.state.storageUpdateDate
    }
  },
  mounted () {
    getStorageUpdateDate(this.$store)
    getAll(this.$store)
    clickTracker('keySearchDrugs')
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
  .multiselect__option--highlight {
    background: $orange;
  }
  .multiselect__input, .multiselect__single {
    vertical-align: baseline;
    vertical-align: -webkit-baseline-middle;
  }
  .select-required .multiselect__tags{
    border: 1px red solid;
  }
</style>

<style scoped lang="scss">
.storage{
  .storageitems{
    @media (max-width: 575px) {
      .header{
        display:none;
      }
      .bold-name{
        font-weight:bold;
      }
      .mobile-boxed{
        border: 1px solid #dee2e6;
      }
      .details{
        .column{
          padding-left: 0 !important;
          padding-right: 0 !important;
        }
      }
    }
    .br-5{
      border-radius:5px;
    }
    .header{
      border-bottom: 1px solid #dee2e6;
      font-weight:bold;
    }
    .bg-hover:hover{
      background:#dee2e6;
    }
    .row{
      .column{
        padding: 0.75rem;
        vertical-align: top;
        @media (min-width: 576px) {
          border-top: 1px solid #dee2e6;
        }
      }
    }
    .details{
      .column{
        border-top:none !important;
      }
      .content{
        border: 1px solid #dee2e7;
        border-radius: 5px;
        .item{
          padding: 10px;
        }
        .item:nth-child(odd){
          background: #f5f2f2;
        }
        .item:not(:last-child){
          margin-bottom:5px
        }
      }
    }
  }
  .description-block {
    display: flex;
    margin-bottom: 1rem;
  }
  .button-container {
    margin-right: 0.5rem;
  }
  .mu-linear-progress{
    border-radius: 0px !important;
  }
  .container-custom{
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    margin-top:20px;
    margin-bottom:20px;
  }
  .tabs{
    width:100%;
  }
  .chip{
    margin: 0 3px 6px 0px;
  }
  .mb-3{
     border: 1px #d8d8d8 solid;
     border-radius: 3px;
   }
   .card-deck, .card-deck .card {
     margin:0;
   }
  .section-name {
    color: white;
    margin: 0;
    font-weight: bold;
    font-size: 25pt;
    text-shadow: 0 0 10px #888
  }
  .section-image {
    padding-top: 25px;
    top: 70px;
    z-index: -1;
    height: 100%;
    max-height: 300px;
    width: 100%;
    background-image: url('../assets/substitution-background.jpg');
    background-position-y: bottom;
    background-size: cover;
  }
  .p-t-10{
    padding-top:10px;
  }
  .min-height-48{
    min-height:48px;
  }
  .border-radius-edges{
    border-radius: 0 5px 5px 0;
  }
}
</style>
